import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'

const styles = theme => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.tooltip + 1,
  }
})

const mapStateToProps = ({ appProgress }) => ({
  activatorsCount: appProgress.activators.length
})

const AppProgressIndicator = ({ classes, activatorsCount, progressProps }) => (
  !!activatorsCount && (
    <div className={classes.root}>
      <LinearProgress color="secondary" {...progressProps} />
    </div>
  )
)

AppProgressIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
  activatorsCount: PropTypes.number.isRequired,
  progressProps: PropTypes.any,
}

export default withStyles(styles)(connect(mapStateToProps)(AppProgressIndicator))
